export class LogDetail {
  message: string;
}



// WEBPACK FOOTER //
// ./src/app/models/log-detail.ts